
<app-login-layout>
    <app-resend-email-notification></app-resend-email-notification>
</app-login-layout>
